import { z } from 'zod';
import { optionalMongoIdString, optionalMongoIdOrNull } from './mongo-id.schema.js';

export const InterestedPartySchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, 'form.validation.nameRequired'),
    type: z.enum(['internal', 'external']),
    category: z.string().optional().or(z.literal('')),
    expectations: z.string().optional().or(z.literal('')),
    obligations: z.string().optional().or(z.literal('')),
    communicationMethod: z.string().optional().or(z.literal('')),
    communicationFrequency: z.string().optional().or(z.literal('')),
    contactPerson: z.string().optional().or(z.literal('')),
    contactEmail: z.string().optional().or(z.literal('')),
    evidenceDocumentId: optionalMongoIdString,
    status: z.enum(['active', 'inactive']).default('active'),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional()
});

export const CreateInterestedPartySchema = InterestedPartySchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true
});
export const UpdateInterestedPartySchema = CreateInterestedPartySchema.partial().extend({
    evidenceDocumentId: optionalMongoIdOrNull
});
